import i18n from "i18next";

class LangService {
    langs = [
        {key: 'fr'},
        {key: 'en'}
    ];
    defaultLang = 'fr';
    defaultTranslatedContent = {'fr': [], 'en': []};

    translatedName(key) {
        if (key in this.defaultTranslatedContent) {
            return i18n.t('lang.' + key);
        }

        return null;
    }
}

export default new LangService();



// WEBPACK FOOTER //
// src/services/lang.js